
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnLaborGrid extends Serenity.EntityGrid<SalesReturnLaborRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnLabor'; }
        protected getIdProperty() { return SalesReturnLaborRow.idProperty; }
        protected getInsertPermission() { return SalesReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnLaborRow.localTextPrefix; }
        protected getService() { return SalesReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}